<template>
  <div>
    <div class="section-titre bg-rouge">
      <div class="container" v-if="!alreadySubmit">
        <h2>
          Restez informé(e)
        </h2>
        <h3 class="mb-0">
          Vous voulez être parmi les premiers à en savoir plus ? Laissez-nous votre email pour recevoir des informations exclusives sur le concept Hornet et ce qu’il annonce.
        </h3>
      </div>
      <div class="container" v-else>
        <h2 class="mb-0 pb-0 text-center">
          <strong
            >Merci pour votre demande d'information,<br />nous revenons vers vous dès que possible.</strong>

        </h2>
      </div>
    </div>
    <br />
    <div
      id="wrapper-form-rester-informer"
      class="wrapper-form-rester-informer container"
    >
      <div class="d-block message text-center mb-5" v-if="alreadySubmit">
        <span>
          Merci et à très bientôt en concession !
        </span>
      </div>

      <form
        class="needs-validation form-horizontal"
        method="POST"
        id="form"
        @keydown.enter.prevent.stop=""
        v-else
      >
        <div class="form-group row mb-0">

          <div
            class="col-lg-12 col-md-6 mb-4"
            v-if="sizeOfObject(villes) === 1"
          >
            <div :class="{ 'wrapper-inputs input-group': true }">
              <select
                name="concession"
                class="form-control select-concess"
                id="concession"
                required="required"
                v-model="form.concession"
              >
                <option value="">
                  Sélectionnez le concessionnaire Honda proche de chez vous*
                </option>
                <option
                  v-for="concess in concessions"
                  :key="concess.id"
                  :value="concess.code"
                >
                  {{ concess.nom_social }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-lg-12 col-md-6 mb-4" v-if="sizeOfObject(villes) > 1">
            <div :class="{ 'wrapper-inputs input-group': true }">
              <select
                name="concession"
                class="form-control select-concess"
                id="concession"
                required="required"
                v-model="form.concession"
              >
                <option value="">
                  Sélectionnez le concessionnaire Honda proche de chez vous*
                </option>
                <option
                  v-for="concess in orderedConcessByVilles"
                  :key="concess.id"
                  :value="concess.code"
                >
                  {{ concess.ville | capitalize }} ({{ concess.nom_social }})
                </option>
              </select>
            </div>
          </div>

          <div
            class="col-lg-12 col-md-6 mb-4"
            v-if="sizeOfObject(villes) === 0 && sizeOfObject(concessions) > 0"
          >
            <div :class="{ 'wrapper-inputs input-group': true }">
              <select
                name="concession"
                class="form-control select-concess"
                id="concession"
                required="required"
                v-model="form.concession"
              >
                <option value="">
                  Sélectionnez le concessionnaire Honda proche de chez vous*
                </option>
                <option
                  v-for="concess in orderedConcessByDpt"
                  :key="concess.id"
                  :value="concess.code_concession"
                >
                  {{ concess.departement.code }}
                  <span v-if="concess.departement.code != null">-</span>
                  <!-- Enlève le tiret si le concess.departement.code est vide -->
                  {{ concess.ville_principale | capitalize }} ({{
                    concess.nom_social
                  }})
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div
              :class="{
                'wrapper-inputs input-group': true,
                focus: form.perso_nom !== '',
              }"
            >
              <input
                type="text"
                name="perso_nom"
                class="form-control"
                id="perso_nom"
                required="required"
                v-model="form.perso_nom"
              />
              <label for="perso_nom" class="control-label"> Nom* </label>
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div
              :class="{
                'wrapper-inputs input-group': true,
                focus: form.perso_prenom !== '',
              }"
            >
              <input
                type="text"
                name="perso_prenom"
                class="form-control"
                id="perso_prenom"
                required="required"
                v-model="form.perso_prenom"
              />
              <label for="perso_prenom" class="control-label"> Prénom* </label>
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div
              :class="{
                'wrapper-inputs input-group': true,
                focus: form.perso_email !== '',
              }"
            >
              <input
                type="text"
                name="perso_email"
                class="form-control"
                id="perso_email"
                required="required"
                v-model="form.perso_email"
              />
              <label for="perso_email" class="control-label"> Email* </label>
            </div>
          </div>
        </div>

        <p class="mentions mt-0 mb-3 text-sm-center">
          <strong>*Tous les champs sont obligatoires</strong>
        </p>

        <div class="wrapper-btn justify-content-center">
          <button
            type="submit"
            class="btn btn-rouge"
            @click.prevent.stop="submit"
          >
            Valider
          </button>
        </div>

        <p class="mentions mb-3 text-sm-center">
          <strong
            >*** En validant vous acceptez nos
            <a
              href="https://moto.honda.fr/motorcycles/useful-links/terms-and-conditions.html"
              target="_blank"
              title="Nouvelle fenêtre"
              >Conditions générales d'utilisation</a
            >
            et notre
            <a
              href="https://moto.honda.fr/motorcycles/useful-links/cookie-policy.html"
              target="_blank"
              title="Nouvelle fenêtre"
              >politique de protection des données</a
            >.</strong
          >
        </p>
        <p
          class="mentions mb-3 text-sm-center"
          v-if="campagne.url.indexOf('fun-family') !== -1"
        >
          <strong>Versions disponibles à l’essai en concession :</strong> Honda
          Moto propose une gamme de motos très large avec plusieurs versions.
          Les concessionnaires Honda ont un nombre de modèles de démonstration
          parfois limité. Si la version de la moto n’est pas disponible en
          concession, votre concessionnaire vous orientera vers la version
          disponible à l’essai. Merci de votre compréhension et bon essai !
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import CookieReader from "../components/CookieReader";
const Form = require("../components/form-validation");
const loaderGeneral = document.getElementById("loader-general");

export default {
  name: "form-rester-informer",
  props: [],
  data() {
    const codeConcess =
      window.location.search.match(/[?&]dealer=(\d{6})(?=&|$)/) ||
      window.location.pathname.match(/(\d{6})/);
    let form = {
      concession: codeConcess && codeConcess.length > 0 ? codeConcess[0] : "",
      model: "",
      perso_civ: "",
      perso_prenom: "",
      perso_nom: "",
      perso_email: "",
      is_demande_ri: true,
      demande_url_page: window.location.href,
    };

    return {
      type: "",
      alreadySubmit: false,
      form: form,
      modeles: window.Catalogue || [],
      concessions: window.Concessions || [],
      villes: window.Villes || [],
      concession_name: window.ConcessionName,
      familles: window.Familles || [],
      campagne: window.Campagne || [],
      familleSelected: window.FamilleSelected || "",
    };
  },
  watch: {
    familleSelected: function () {
      if (this.modeles.length === 1) {
        this.form.model = this.modeles[0].id
      } else if (this.filteredModeles.length === 1) {
        this.form.model = this.filteredModeles[0].id
      } else {
        this.form.model = ""
      }
    },
  },
  computed: {
    sortedModeles: function () {
      return this.modeles.sort((a, b) => (a.ordre < b.ordre ? 1 : -1));
    },
    orderedConcessByVilles: function () {
      return _.orderBy(this.concessions, "ville");
    },
    orderedConcessByDpt: function () {
      return _.orderBy(this.concessions, [
        "departement.code",
        "ville_principale",
        "nom_social",
      ]);
    },
    filteredModeles: function () {
      return this.modeles.filter((model) =>
        this.familleSelected !== ""
          ? Number(model.familles[0].id) === Number(this.familleSelected)
          : true
      );
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  mounted() {
    document.addEventListener("familyChoice", (e) => {
      this.familleSelected = parseInt(e.detail.family);
    });

    // TODO trouver une autre solution que d'utiliser le campagne.id
    const familyCheck = [2, 4, 6];
    this.type = familyCheck.includes(this.campagne.id) ? "moto" : "scooter";

    this.form.model = this.campagne.modeles;

    this.familleSelected =
      this.familles.length === 1
        ? this.familles[0]["id"]
        : this.familleSelected !== ""
        ? this.familleSelected[0]["id"]
        : "";
    let myRules = {
      concession: {
        required: true,
      },
      modeles: {
        required: true,
      },
      perso_nom: {
        required: true,
        verifName: true,
      },
      perso_prenom: {
        required: true,
        verifName: true,
      },
      perso_email: {
        required: true,
        verifEmail: true,
      },
      // perso_telephone: {
      //   required: true,
      //   verifTel: true,
      // },
      familles: {
        required: true,
      },
    };
    let myMessages = {
      concession: {
        required: "Veuillez sélectionner un concessionnaire",
      },
      modeles: {
        required:
          "Veuillez sélectionner " +
          (this.campagne.url.indexOf("forza-family") !== -1
            ? "le scooter Forza"
            : "la version") +
          " que vous souhaitez essayer",
      },
      perso_nom: {
        required: "Le champ « Nom » est obligatoire",
      },
      perso_prenom: {
        required: "Le champ « Prénom » est obligatoire",
      },
      perso_email: {
        required: "Le champ « Email » est obligatoire",
        verifEmail:
          "Cet email semble être invalide (Format XXX@XXX.XXX attendu)",
      },
      // perso_telephone: {
      //   required: "Le champ « Téléphone » est obligatoire",
      //   verifTel: "Ce numéro semble être invalide (Format 10 chiffres attendu)",
      // },
      familles: {
        required:
          "Veuillez sélectionner " +
          (this.type == "scooter" ? "le " : "la ") +
          this.type +
          " que vous souhaitez essayer",
      },
    };
    Form.initialize(".needs-validation", myRules, myMessages);
  },
  methods: {
    checkObsoleteBrowsers() {
      return (
        navigator.userAgent.indexOf("Trident") > 0 ||
        navigator.userAgent.indexOf("Edge") > 0 ||
        navigator.userAgent.indexOf("MSIE") > 0
      );
    },
    pageScroll(target, margin = 0) {
      let ww = Math.max($(window).width(), window.innerWidth),
        offset = ww > 767 ? 60 : 40,
        offsetWithMargin = offset + margin;
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - (offsetWithMargin - 1),
          },
          1000,
          "easeInOutExpo"
        );
    },
    sizeOfObject(obj) {
      if (typeof obj == "object") {
        let size = 0,
          key;
        for (key in obj) {
          if (obj.hasOwnProperty(key)) size++;
        }
        return size;
      } else {
        return obj.length;
      }
    },
    submit() {
      let formSubmitted = Form.submission(".needs-validation");
      if (formSubmitted.length > 0) {
        let margin = 0;
        if (
          this.campagne.url.indexOf("forza-family") !== -1 &&
          formSubmitted[0].element.name === "modeles"
        ) {
          margin = 55;
        } else if (
          this.campagne.url.indexOf("fun-family") !== -1 &&
          formSubmitted[0].element.name === "familles"
        ) {
          margin = 45;
        } else {
          margin = 25;
        }
        this.pageScroll(formSubmitted[0].element, margin);
        return false;
      }
      loaderGeneral.style.display = "block";
      if (CookieReader.exists("p_moto")) {
        this.form.id_provenance = CookieReader.get("p_moto");
      }
      axios
        .post(window.location.pathname, this.form)
        .then(() => {
          this.pageScroll("#form-rester-informer");
          this.alreadySubmit = true;
          loaderGeneral.style.display = "none";
          dataLayer.push({
            event: "Formulaire",
            eventCategory: "Essai",
            eventLabel: this.form.model,
            eventAction: "Succès Formulaire",
            idConcessionFormulaire: this.form.concession,
          });
        })
        .catch((e) => {
          // Shit hits the fan
          loaderGeneral.style.display = "none";
          console.error(e);
        });
    },
    countVilles() {
      this.concessions;
    },
  },
};
</script>
